import { Link } from "react-router-dom";
import { useEffect, useRef, useState } from "react";

const WHATSAPP_NUMBER = "51994692096";
function waLink(message) {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

/** Reveal suave sin librerías */
function Reveal({ children, className = "", delay = 0 }) {
  const ref = useRef(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShow(true);
          obs.disconnect();
        }
      },
      { threshold: 0.12 }
    );

    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      style={{ transitionDelay: `${delay}ms` }}
      className={[
        "transition-all duration-700 ease-out will-change-transform",
        show ? "opacity-100 translate-y-0 blur-0" : "opacity-0 translate-y-8 blur-[10px]",
        className,
      ].join(" ")}
    >
      {children}
    </div>
  );
}

function Divider({ tone = "light" }) {
  return (
    <div className="mx-auto max-w-7xl px-6 py-14">
      <div className={tone === "dark" ? "h-px bg-white/10" : "h-px bg-black/5"} />
    </div>
  );
}

export default function DondeComprar() {
  const waMsg =
    "Hola, quiero comprar gelatina. Producto/Bloom: __. Cantidad: __ kg. Ciudad: __. Envío por: Olva / Shalom. (Opcional: uso/aplicación: __).";

  return (
    <main className="bg-white text-slate-900">
      {/* ========= HERO ========= */}
      <section className="mx-auto max-w-7xl px-6 pt-10 md:pt-14">
        <Reveal>
          <p className="text-xs font-semibold tracking-[0.18em] text-slate-500">
            DÓNDE COMPRAR
          </p>

          <h1 className="mt-6 text-5xl md:text-7xl font-semibold tracking-tight">
            Compra directa.
            <span className="text-slate-300"> Envíos a todo el Perú.</span>
          </h1>

          <p className="mt-9 max-w-2xl text-lg md:text-xl leading-relaxed text-slate-600">
            Coordinamos la compra por WhatsApp y realizamos envíos a nivel nacional por{" "}
            <span className="text-slate-900 font-medium">Olva</span> o{" "}
            <span className="text-slate-900 font-medium">Shalom</span>.
          </p>

          <div className="mt-10 flex flex-wrap gap-3">
            <a
              href={waLink(waMsg)}
              target="_blank"
              rel="noreferrer"
              className="inline-flex rounded-full bg-slate-900 px-6 py-3 text-[14px] font-medium text-white shadow-sm transition hover:bg-black active:scale-[0.99]"
            >
              Comprar por WhatsApp
            </a>

            <Link
              to="/gelatinas"
              className="inline-flex rounded-full border border-black/10 bg-white px-6 py-3 text-[14px] font-medium text-slate-900 shadow-sm transition hover:bg-slate-50 active:scale-[0.99]"
            >
              Ver gelatinas
            </Link>
          </div>
        </Reveal>
      </section>

      <Divider />

      {/* ========= PASOS (CLARO, SIN “CAJITAS”) ========= */}
      <section className="bg-gradient-to-b from-[#fbf7ef] via-white to-white">
        <div className="mx-auto max-w-7xl px-6 py-20 md:py-28">
          <Reveal>
            <p className="text-xs font-semibold tracking-[0.18em] text-slate-500">
              PROCESO
            </p>

            <h2 className="mt-6 text-4xl md:text-6xl font-semibold tracking-tight">
              Tres simples 
              <span className="text-slate-400"> pasos.</span>
            </h2>

            <p className="mt-9 max-w-2xl text-lg leading-relaxed text-slate-600">
              Para comprar solo necesitamos el producto (o Bloom), cantidad y ciudad. El resto se
              coordina por WhatsApp.
            </p>
          </Reveal>

          <div className="mt-16 grid gap-14 md:grid-cols-3">
            <Reveal delay={80}>
              <div className="space-y-5">
                <p className="text-xs font-semibold tracking-[0.18em] text-slate-500">01</p>
                <p className="text-2xl font-semibold tracking-tight">Escríbenos</p>
                <p className="text-base leading-relaxed text-slate-600">
                  Indica Bloom/producto, cantidad y ciudad. Si es para empresa, menciona el uso.
                </p>
                <div className="pt-6">
                  <div className="h-px bg-black/5" />
                </div>
              </div>
            </Reveal>

            <Reveal delay={140}>
              <div className="space-y-5">
                <p className="text-xs font-semibold tracking-[0.18em] text-slate-500">02</p>
                <p className="text-2xl font-semibold tracking-tight">Confirmamos</p>
                <p className="text-base leading-relaxed text-slate-600">
                  Verificamos disponibilidad, presentación y método de envío (Olva o Shalom).
                </p>
                <div className="pt-6">
                  <div className="h-px bg-black/5" />
                </div>
              </div>
            </Reveal>

            <Reveal delay={200}>
              <div className="space-y-5">
                <p className="text-xs font-semibold tracking-[0.18em] text-slate-500">03</p>
                <p className="text-2xl font-semibold tracking-tight">Enviamos</p>
                <p className="text-base leading-relaxed text-slate-600">
                  Despacho a todo el Perú por Olva o Shalom, según tu preferencia.
                </p>
                <div className="pt-6">
                  <div className="h-px bg-black/5" />
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      {/* ========= ENVÍOS (CLARO, SIN NEGRO) ========= */}
<section className="bg-gradient-to-b from-[#f6f7f9] via-white to-white">
  <div className="mx-auto max-w-7xl px-6 py-24 md:py-32">
    <Reveal>
      <p className="text-xs font-semibold tracking-[0.18em] text-slate-500">
        ENVÍOS
      </p>

      <h3 className="mt-6 text-4xl md:text-6xl font-semibold tracking-tight text-slate-900">
        Envíos a todo el Perú.
      </h3>

      <p className="mt-9 max-w-2xl text-lg leading-relaxed text-slate-600">
        Realizamos despachos a nivel nacional mediante agencias de transporte.
        Coordinamos el envío según tu ciudad y preferencia.
      </p>
    </Reveal>

    <div className="mt-20 grid gap-16 md:grid-cols-12">
      <div className="md:col-span-7">
        <Reveal delay={120}>
          <div className="space-y-14">
            <div>
              <p className="text-2xl font-semibold tracking-tight text-slate-900">
                Olva Courier
              </p>
              <p className="mt-3 text-slate-600 leading-relaxed">
                Envíos rápidos a capitales y principales ciudades del país.
              </p>
            </div>

            <div className="h-px bg-black/5" />

            <div>
              <p className="text-2xl font-semibold tracking-tight text-slate-900">
                Shalom
              </p>
              <p className="mt-3 text-slate-600 leading-relaxed">
                Alternativa eficiente para envíos interprovinciales y cargas mayores.
              </p>
            </div>

            <div className="h-px bg-black/5" />

            <div>
              <p className="text-2xl font-semibold tracking-tight text-slate-900">
                Coordinación directa
              </p>
              <p className="mt-3 text-slate-600 leading-relaxed">
                Confirmamos producto, cantidad y agencia antes del despacho.
              </p>
            </div>
          </div>
        </Reveal>
      </div>

      <div className="md:col-span-5">
        <Reveal delay={180}>
          <div className="rounded-[36px] bg-white p-10 md:p-12 shadow-[0_20px_60px_rgba(0,0,0,0.06)]">
            <p className="text-xs font-semibold tracking-[0.18em] text-slate-500">
              COMPRA
            </p>
            <p className="mt-5 text-3xl md:text-4xl font-semibold tracking-tight text-slate-900">
              Compra directa por WhatsApp
            </p>
            <p className="mt-6 text-slate-600 leading-relaxed">
              Escríbenos con el producto o Bloom, cantidad y ciudad.
              Coordinamos el envío y la disponibilidad.
            </p>

            <div className="mt-10">
              <a
                href={waLink(waMsg)}
                target="_blank"
                rel="noreferrer"
                className="inline-flex rounded-full bg-slate-900 px-6 py-3 text-[14px] font-medium text-white transition hover:bg-black active:scale-[0.99]"
              >
                Escribir por WhatsApp
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </div>
</section>

    </main>
  );
}
